import { useCallback } from 'react'

import {
  useUpdateOrganizationSettings,
  useUserOrganization,
  useUserOrganizationSettings,
} from '@modules-deprecated/app/organization'

import { useIsAutoCegidIntegrationEnabled } from '../../../hooks/useIsAutoCegidIntegrationEnabled'

export const useAutomaticEInvoiceSettingToggle = () => {
  const { update: updateOrganizationSettings } = useUpdateOrganizationSettings()
  const { organization } = useUserOrganization()
  const { isAutoCegidIntegrationEnabled } = useIsAutoCegidIntegrationEnabled()

  const { organizationSettings } = useUserOrganizationSettings()
  const isAutoForwardEInvoicesEnabled = organizationSettings?.eInvoiceAutomaticCegidIntegration === '1'

  const update = useCallback(
    (value: '0' | '1') => {
      if (!organization?.id) {
        throw new Error('Cannot update setting without organization')
      }

      updateOrganizationSettings({
        key: 'eInvoiceAutomaticCegidIntegration',
        organizationId: organization.id,
        value,
      })
    },
    [organization, updateOrganizationSettings],
  )

  const enable = useCallback(() => {
    if (!isAutoCegidIntegrationEnabled) {
      throw new Error('Cannot enable when automaticCegidIntegration is OFF')
    }

    return update('1')
  }, [update, isAutoCegidIntegrationEnabled])

  const disable = useCallback(() => {
    return update('0')
  }, [update])

  return {
    enable,
    disable,
    isAutoForwardEInvoicesEnabled,
    isAutoCegidIntegrationEnabled,
  }
}
